import { render, staticRenderFns } from "./homeDashboardTransactionStatistics.vue?vue&type=template&id=2616ab27&scoped=true"
import script from "./homeDashboardTransactionStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardTransactionStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTransactionStatistics.vue?vue&type=style&index=0&id=2616ab27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616ab27",
  null
  
)

export default component.exports